import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { IPImageSearchPatentApi, IPImageSearchPatentApiImpl } from '@/components/ai/plugins/image-search/services/apis/patent';
import { IPNewsletterApi, IPNewsletterApiImpl } from '@/components/ai/plugins/tech-newsletter/services/apis/newsletter';
import { MonitorFromWorkspaceApi, MonitorFromWorkspaceApiImpl } from '@/components/ai/plugins/tech-newsletter/services/apis/monitor-from-workspace';

export const ipServiceContainer = new ContainerModule(bind => {
    bind(IPImageSearchPatentApi).to(IPImageSearchPatentApiImpl);
    bind(IPNewsletterApi).to(IPNewsletterApiImpl);
    bind(MonitorFromWorkspaceApi).to(MonitorFromWorkspaceApiImpl);
});
